import images from "./images";

const About = {
  sub: "know about us",
  heading: "about us",
  title: "We take care of print, you take care of business",
  description: [
    "We take care of print, you take care of business. Our team delivers high-quality printing solutions so you can focus on what you do best. We take care of print, you take care of business. Our team delivers high-quality printing solutions so you can focus on what you do best.",
  ],
  image: {
    src: images.about,
    alt: "About-Image",
  },
  button: {
    text: "Contact Us",
    link: "Contact-us",
  },
};

export default About;